import React, { useState, useEffect, useCallback } from "react";
import { FaPen, FaTrash, FaTimes } from "react-icons/fa";
import "./AdminAttendance.css";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Admin/SubHeader";
import AttendanceLayout from "../../layouts/Admin/AttendanceLayout";

const AdminAttendance = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <AttendanceLayout />
    </>
  );
};

export default AdminAttendance;
